export const InvalidSameAddressKey = 'invalidSameAddress';
export const CountryValidationKey = 'countryValidationKey';
